/**
 * tomass-summary コンポーネント専用i18n定数
 */

export const TOMASS_SUMMARY_I18N = {
  breadcrumb: {
    home: $localize`:@@home.tomassSummary.breadcrumb.home:ホーム`,
    userList: $localize`:@@home.tomassSummary.breadcrumb.userList:ユーザー一覧`,
    tomassSummary: $localize`:@@home.tomassSummary.breadcrumb.tomassSummary:TOMASSサマリー`,
  },

  pageHeader: {
    title: $localize`:@@home.tomassSummary.title.tomassSummary:TOMASSサマリー`,
    description: $localize`:@@home.tomassSummary.description.aggregateTomassRecords:期間・アカウント条件でTOMASSデータを集計し、サマリー・比率チャート・地域別マップ・計測実施回数を確認できます。`,
  },

  // ラベル
  label: {
    unknown: $localize`:@@home.tomassSummary.label.unknown:不明`,
    other: $localize`:@@home.tomassSummary.label.other:その他`,
    underTen: $localize`:@@home.tomassSummary.label.underTen:10歳未満`,
    overHundred: $localize`:@@home.tomassSummary.label.overHundred:100歳以上`,
    tenOrMore: $localize`:@@home.tomassSummary.label.tenOrMore:10回以上`,
    male: $localize`:@@home.tomassSummary.label.male:男性`,
    female: $localize`:@@home.tomassSummary.label.female:女性`,
  },

  // 回数のフォーマット
  attemptsFormat: (count: number) =>
    $localize`:@@home.tomassSummary.attemptsFormat:${count}:count:回`,

  // 計測頻度テーブル
  frequencyTable: {
    title: $localize`:@@home.tomassSummary.frequencyTable.title:計測実施回数（人数）`,
    date: $localize`:@@home.tomassSummary.frequencyTable.date:計測日`,
    measurementCount: $localize`:@@home.tomassSummary.frequencyTable.measurementCount:計測件数`,
    accountCount: $localize`:@@home.tomassSummary.frequencyTable.accountCount:計測アカウント数`,
    scoreRatio: $localize`:@@home.tomassSummary.frequencyTable.scoreRatio:A:B:C比率`,
    scoreCount: $localize`:@@home.tomassSummary.frequencyTable.scoreCount:A/B/C件数`,
    accountList: $localize`:@@home.tomassSummary.frequencyTable.accountList:アカウント`,
    estimatedRegion: $localize`:@@home.tomassSummary.frequencyTable.estimatedRegion:計測実施地域`,
    total: $localize`:@@home.tomassSummary.frequencyTable.total:合計`,
  },

  // 地域別マップ
  map: {
    title: $localize`:@@home.tomassSummary.map.title:地域別計測マップ`,
    noGeoData: $localize`:@@home.tomassSummary.map.noGeoData:位置情報データがありません`,
    metricLabel: $localize`:@@home.tomassSummary.map.metricLabel:表示軸`,
    metricScoreC: $localize`:@@home.tomassSummary.map.metricScoreC:C判定比率`,
    metricSeniorRatio: $localize`:@@home.tomassSummary.map.metricSeniorRatio:高齢比率（70歳以上）`,
    metricVolume: $localize`:@@home.tomassSummary.map.metricVolume:計測件数`,
    overlayLabel: $localize`:@@home.tomassSummary.map.overlayLabel:重ね表示`,
    overlayScoreC: $localize`:@@home.tomassSummary.map.overlayScoreC:C判定率（枠色）`,
    overlaySeniorRatio: $localize`:@@home.tomassSummary.map.overlaySeniorRatio:高齢比率（枠太さ）`,
    overlayVolume: $localize`:@@home.tomassSummary.map.overlayVolume:件数（ラベル）`,
    legendHintFill: $localize`:@@home.tomassSummary.map.legendHintFill:セル塗り: 主指標`,
    legendHintStrokeScoreC: $localize`:@@home.tomassSummary.map.legendHintStrokeScoreC:枠色: C判定率`,
    legendHintStrokeSenior: $localize`:@@home.tomassSummary.map.legendHintStrokeSenior:枠太さ: 高齢比率`,
    legendHintCount: $localize`:@@home.tomassSummary.map.legendHintCount:セル中央: 件数`,
    scoreA: $localize`:@@home.tomassSummary.map.scoreA:スコアA（良好）`,
    scoreB: $localize`:@@home.tomassSummary.map.scoreB:スコアB（中程度）`,
    scoreC: $localize`:@@home.tomassSummary.map.scoreC:スコアC（要注意）`,
  },

  // ツールバー
  toolbar: {
    account: $localize`:@@home.tomassSummary.toolbar.account:アカウント`,
    allAccounts: $localize`:@@home.tomassSummary.toolbar.allAccounts:全アカウント`,
    aggregate: $localize`:@@home.tomassSummary.toolbar.aggregate:集計`,
    resetPeriod: $localize`:@@home.tomassSummary.toolbar.resetPeriod:期間を初期化`,
    pdfOutput: $localize`:@@home.tomassSummary.toolbar.pdfOutput:PDF出力`,
  },

  // KPI
  kpi: {
    records: $localize`:@@home.tomassSummary.kpi.records:計測件数`,
    aggregationPeriod: $localize`:@@home.tomassSummary.kpi.aggregationPeriod:集計期間`,
    accounts: $localize`:@@home.tomassSummary.kpi.users:対象アカウント数`,
    avgAgeGroup: $localize`:@@home.tomassSummary.kpi.avgAgeGroup:参加者中央値年代`,
    avgPst: $localize`:@@home.tomassSummary.kpi.avgPst:平均PST`,
    avgGpst: $localize`:@@home.tomassSummary.kpi.avgGpst:平均GPST`,
    unit: {
      count: $localize`:@@home.tomassSummary.kpi.unit.count:件`,
      items: $localize`:@@home.tomassSummary.kpi.unit.people:件`,
      seconds: $localize`:@@home.tomassSummary.kpi.unit.seconds:秒`,
    },
  },

  // チャートタイトル
  chart: {
    ageParticipation: $localize`:@@home.tomassSummary.chart.ageParticipation:年齢別参加件数`,
    genderRatio: $localize`:@@home.tomassSummary.chart.genderRatio:男女比`,
    crackerRatio: $localize`:@@home.tomassSummary.chart.crackerRatio:結果比率`,
    crackerHistogram: $localize`:@@home.tomassSummary.chart.crackerHistogram:結果ヒストグラム（年代別）`,
    crackerHistogramSub: $localize`:@@home.tomassSummary.chart.crackerHistogramSub:A/B/C積み上げ`,
    noData: $localize`:@@home.tomassSummary.chart.noData:データがありません`,
  },

  // エラーメッセージ
  error: {
    fetchFailed: $localize`:@@home.tomassSummary.error.fetchFailed:TOMASSレコードの取得に失敗しました。`,
  },
} as const;

export type TomassSummaryI18n = typeof TOMASS_SUMMARY_I18N;
